import React from "react";
import Dashboard from "../../common/Dashboard";
import DashboardConfig from "../system-admin/Dashboard/DashboardConfig";

export default function DEOAdminDashboard() {
  return (
    <Dashboard sidebarType="Data Entry Operator">
      <DashboardConfig />
    </Dashboard>
  );
}
